<template>
    <div class="page bg-gray page-flex pb-navs">
        <backTitleBar></backTitleBar>

        <div class="search-content">


            <div class="alifont icon-xpsousuo"></div>

            <input type="text" placeholder="搜索订单号" class="content-input" v-model="pageInfo.orderNo"
                   @keyup.enter="handleQuery">
            <div class="search-btn click" @click="handleQuery">搜索</div>
        </div>

        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div>
                    <div v-for="item in data" class="table-item">
                        <div class="pd-250 bd-bot">
                            <div class="fs-30 color-333">{{item.day + ' ' + item.time}}</div>
                        </div>
                        <div class="flex-between mt-25">
                            <div class="fs-32 color-333">用户名：{{item.nickname}}</div>
                            <div class="fs-32 color-org">￥{{item.paidIn || 0}}</div>
                        </div>
                        <div class="item-btns" v-if="item.videoUrlView || item.orderId">
                            <div class="click btn" @click="showVideo(item)">视频查看</div>
                            <div class="click btn" @click="getScrollerPosition();$router.push({name:'orderDetail',query:{orderId:item.orderId}})" v-if="item.orderId">订单查看</div>
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
        <navs :shopId="shopId"></navs>
        <van-dialog  v-model="videoShow" @close="closeDialog">
            <div class="video-box">
                <div class="video-text" @click="getVideo(0)">
                    <div class="left">开门视频</div>
                    <div class="right" v-if="entity.openVideoView == '未上传'">
                        <span v-if="!openVideoLoading">点击上传</span>
                        <span v-else>正在上传，请等待</span>
                    </div>
                </div>
                <div class="video" v-if="entity.openVideoView != '未上传' && entity.openVideoView != ''">
                    <video controls="controls" :src="entity.openVideoView" style="width: 100%;height: 100%;">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
            </div>
            <div class="video-box">
                <div class="video-text" @click="getVideo(1)">
                    <div class="left">关门视频</div>
                    <div class="right" v-if="entity.closeVideoView == '未上传'">
                        <span v-if="!closeVideoLoading">点击上传</span>
                        <span v-else>正在上传，请等待</span>
                    </div>
                </div>
                <div class="video"  v-if="entity.closeVideoView != '未上传' && entity.closeVideoView != ''">
                    <video controls="controls" :src="entity.closeVideoView" style="width: 100%;height: 100%;">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
            </div>
        </van-dialog>
    </div>

</template>
<script>
    import navs from "./equipment-navs"
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import {uploadDoorVideo,getDoorLockLogDetail} from "@/api/shop"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: 'openList',
        mixins: [initData,routerBack],
        components: {navs,backTitleBar},

        data() {
            return {
                shopId: '',
                videoShow:false,
                isChecked:false,
                videoList:[],
                entity:{},
                closeVideoLoading:false,
                openVideoLoading:false,
                timer : null,
                firstEnter:true,
            }
        },
        created() {
            this.$store.state.showFooter = false;

            this.$store.state.shop_nav_value = 2;
            if (this.$route.query.token) {
                let token = this.$route.query.token
                let bol = true;
                this.$store.dispatch('setToken', {token, bol});
            }
            if (this.$route.query.shopId) {
                this.shopId = this.$route.query.shopId;
            }
            this.firstEnter = false;
        },
        methods: {
            beforeInit() {
                this.params = {page: this.page, limit: this.limit, shopId: this.shopId};
                this.url = 'shop/doorLockLog';
                let query = this.pageInfo;
                for (var key in query) {
                    if (query[key]) {
                        this.params[key] = query[key]
                    }
                }
                return true
            },

            showVideo(data){
                let array = data.videoUrlView.split('|');
                data.openVideoView = array[0];
                data.closeVideoView = array[1]
                this.entity = data;
                this.videoShow = true;
            },
            closeDialog(){
                clearInterval(this.timer);
                this.entity = {};
                this.closeVideoLoading = false;
                this.openVideoLoading = false;
            },
            //请求上传视频
            getVideo(type){
                if(type == 0 && this.entity.openVideoView != '未上传'){
                    return
                }
                if(type == 1 && this.entity.closeVideoView != '未上传'){
                    return
                }
                let params = {
                    recordId:this.entity.recordId,
                    operate:type
                };
                if(this.openVideoLoading || this.closeVideoLoading){
                    this.$toast("视频正在上传中，请稍等");
                    return;
                }
                let _this = this;
                let times = 0
                uploadDoorVideo(params).then(res=>{
                    if(type == 0){
                        this.openVideoLoading = true;
                        _this.timer = setInterval(function(){
                            times += 1;
                            getDoorLockLogDetail(params).then(respon=>{
                                if(respon.data.videoUrlView){
                                    _this.$set(_this.entity,'openVideoView',respon.data.videoUrlView);
                                    _this.openVideoLoading = false;
                                    _this.handleQuery();
                                    clearInterval(_this.timer);
                                }
                                if(times == 15){
                                    _this.openVideoLoading = false;
                                    clearInterval(_this.timer);
                                }
                            })
                        },6000)
                    }else if(type == 1){
                        this.closeVideoLoading = true;
                        _this.timer = setInterval(function(){
                            times += 1;
                            getDoorLockLogDetail(params).then(respon=>{
                                if(respon.data.videoUrlView){
                                    _this.$set(_this.entity,'closeVideoView',respon.data.videoUrlView);
                                    _this.closeVideoLoading = false;
                                    _this.handleQuery();
                                    clearInterval(_this.timer);
                                }
                                if(times == 15){
                                    _this.closeVideoLoading = false;
                                    clearInterval(_this.timer);
                                }
                            })
                        },6000)
                    }
                })
            },
        },

        beforeRouteEnter(to,from,next){
            console.log(to);
            // to.meta.keepAlive = true;
            next();
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.timer);
            if(to.name == 'orderDetail'){
                this.isKeepAlive = false;
            }else{
                this.isKeepAlive = true;
            }
            next()
        },
        activated(){
            if(this.isKeepAlive){
                this.shopId = this.$route.query.shopId;
                this.orderNo = '';
                this.handleQuery();
            }
        },
    }
</script>
<style lang="scss" scoped>

    .search-content{
        margin: .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .2rem .4rem;
        display: flex;
        align-items: center;
        .alifont{
            font-size: .36rem;
            color: #919BA6;
            margin-right: .1rem;
        }
        .content-input{
            flex: 1;
            border: none;
            font-size: .3rem;
            line-height: .42rem;
            color: #919BA6;
        }
        .search-btn{
            font-size: .3rem;
            line-height: .42rem;
            color: $main-color;
            margin-left: .2rem;
        }
    }


    .video-box{
        border-bottom: 0.01rem solid #e4e4e4;
        font-size: .28rem;
        .video-text{
            padding: .15rem .3rem;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            .left{
                color: #333333;
            }
            .right{
                color: #999;
            }
        }
        .video{
            margin-bottom: .2rem;
            video{
                max-width: 100%;
                max-height: 3rem;
            }
        }
    }
    .item-btns {
        margin-top: .35rem;
        display: flex;
        .btn {
            flex: 1;
            background: #F5F6FA;
            border-radius: .24rem;
            height: .84rem;
            text-align: center;
            line-height: .84rem;
            color: #33415E;
            font-size: .3rem;
            &:nth-child(2) {
                margin-left: .2rem;
            }
        }
    }
    .table-item{
        margin: .2rem .3rem;
        padding: 0 .3rem .2rem;
        background: #fff;
        border-radius: .2rem;
        overflow: hidden;
    }
    .table-item:nth-child(1) {
        margin-top: 0;
    }
    .pb-navs{
        padding-bottom: 1.34rem;
    }
</style>



// WEBPACK FOOTER //
// openLogList.vue?c78e57a8